import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-8" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-label" }
const _hoisted_5 = { class: "card-toolbar gap-4" }
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "table align-middle table-row-dashed fs-6 gy-5" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { style: {"min-width":"180px"} }

import { useStore } from "@/store";
import { useI18n } from "vue-i18n";
import { ref, onMounted } from "vue";
import { ElNotification } from "element-plus";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import TradeServices from "../services/TradeServices";
import { InfoFilled } from "@element-plus/icons-vue";
import checklistCreate from "@/projects/tenant/modules/trade/components/ChecklistCreate.vue";
import checklistUpdate from "@/projects/tenant/modules/trade/components/ChecklistUpdate.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'OffsetCheck',
  setup(__props) {

const { t } = useI18n();
const store = useStore();
const isLoading = ref(false);
const checklist = ref(Array<any>());
const checklistCreateRef = ref<any>(null);
const checklistUpdateRef = ref<any>(null);
const siteId = ref(store.state.AuthModule.config.siteId);

const showChecklistCreate = () => {
  checklistCreateRef.value?.show(siteId.value);
};

const showChecklistUpdate = (item: any) => {
  checklistUpdateRef.value?.show(item, siteId.value);
};

const getChecklist = async () => {
  isLoading.value = true;
  try {
    const res = await TradeServices.getChecklist();
    checklist.value = res;
  } catch (error) {
    console.log(error);
  }
  isLoading.value = false;
};

const activeToggle = async (item: any) => {
  isLoading.value = true;

  try {
    await TradeServices.updateChecklist(item.id, item);
    ElNotification.success({
      title: "Success",
      offset: 100,
    });
    getChecklist();
  } catch (error) {
    console.log(error);
  }
  isLoading.value = false;
};

const deleteChecklist = async (id: number) => {
  isLoading.value = true;
  try {
    await TradeServices.deleteChecklist(id);
    getChecklist();
  } catch (error) {
    console.log(error);
  }
  isLoading.value = false;
};

const resetCache = async () => {
  isLoading.value = true;
  try {
    await TradeServices.resetCache();
    MsgPrompt.success(t("tip.submitSuccess")).then(() => {
      getChecklist();
    });
  } catch (error) {
    MsgPrompt.error(t("tip.submitError"));
  }
  isLoading.value = false;
};

const onEventSubmitted = () => {
  getChecklist();
};

onMounted(() => {
  getChecklist();
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t("title.offsetCheckList")), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: showChecklistCreate
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.addOffsetCheck")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "warning",
          onClick: resetCache
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.resetCache")), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("table", _hoisted_7, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("status.active")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.name")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.members")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("action.action")), 1)
          ])
        ]),
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_8, [
              _createVNode(_component_LoadingRing)
            ]))
          : (!isLoading.value && checklist.value.length === 0)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_9, [
                _createVNode(_component_NoDataBox)
              ]))
            : (_openBlock(), _createElementBlock("tbody", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(checklist.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", null, [
                      _createVNode(_component_el_switch, {
                        modelValue: item.status,
                        "onUpdate:modelValue": ($event: any) => ((item.status) = $event),
                        "active-value": 1,
                        "inactive-value": 0,
                        onChange: ($event: any) => (activeToggle(item))
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                    ]),
                    _createElementVNode("td", null, _toDisplayString(item.name), 1),
                    _createElementVNode("td", null, _toDisplayString(item.accountNumbers), 1),
                    _createElementVNode("td", _hoisted_11, [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: ($event: any) => (showChecklistUpdate(item))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("action.update")), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]),
                      _createVNode(_component_el_popconfirm, {
                        "confirm-button-text": "Yes",
                        "cancel-button-text": "No",
                        icon: _unref(InfoFilled),
                        "icon-color": "#626AEF",
                        title: "Are you sure?",
                        onConfirm: ($event: any) => (deleteChecklist(item.id))
                      }, {
                        reference: _withCtx(() => [
                          _createVNode(_component_el_button, { type: "danger" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("action.delete")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["icon", "onConfirm"])
                    ])
                  ]))
                }), 128))
              ]))
      ])
    ]),
    _createVNode(checklistCreate, {
      ref_key: "checklistCreateRef",
      ref: checklistCreateRef,
      onEventSubmit: onEventSubmitted
    }, null, 512),
    _createVNode(checklistUpdate, {
      ref_key: "checklistUpdateRef",
      ref: checklistUpdateRef,
      onEventSubmit: onEventSubmitted
    }, null, 512)
  ]))
}
}

})